import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7a5ba45e"
import script from "./Header?vue&type=script&lang=ts&external"
export * from "./Header?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports